// features/employee/fund/services/employeeFundApi.js

import { api } from "lib";

export const getMembershipList = (employeeId, params) =>
    api.get(`/v1/fund-memberships/${employeeId}`, { ...params, employeeId });

export const getMembershipById = (employeeId, id) =>
    api.get(`/v1/fund-memberships/${employeeId}/${id}`);

export const getMembershipSummary = (employeeId, year) =>
    api.get(`/v1/fund-memberships/${employeeId}/summary`, { params: { year } });

export const createMembership = (employeeId, params) =>
    api.post(`/v1/fund-memberships/create`, { ...params, employeeId });

export const updateMembership = (employeeId, id, payload) =>
    api.put(`/v1/fund-memberships/${employeeId}/${id}`, payload);

export const deleteMembership = (employeeId, id) =>
    api.delete(`/v1/fund-memberships/${employeeId}/${id}`);
